<template lang="pug">
.tp
  .tpBlock
    .tpTop
      //標題區
      .tpLeft
        .tpTitle {{ showPost.title }}
        .tpSubTitle {{ showPost.domain }} | {{ showPost.authors }}
        .tpPro {{ showPost.pro }}
        //檔案
        a.tpFileBlock(
          v-if="showPost.file"
          :href="showPost.file.src || showPost.file" 
          target="blank"
        )
          box
      //封面照
      //- .tpPic(:style="{backgroundImage:　'url(' + showPost.cover + ')', backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}")
      ImgLoader.tpPic(:img="showPost.cover" :style="{'--bgPos': 'center'}")
    //文字內容
    .toContent(v-html="showPost.concept || showPost.body")

    //TAG
    .TpTagBlock
      .TpTag(v-for="tag in showPost.tags") # {{ tag }}
</template>

<script>
import {warn} from '@/utils/msg'
import box from '@/views/Teach/box'
import { fetchLesson } from '@/api/client/Lesson'
import { GetProject } from '@/api/client/Project'
export default {
  components: { box },
  async created() {
    const { postid: lessonId } = this.$route.params
    const { dbId, projectId } = this.$route.query
    const { data: projectData } = await GetProject(projectId)
    if (!projectData) {
      warn('找不到資料')
      this.$router.push({name: 'NotFound'})
      return
    }
    const { name: projectName } = projectData
    this.showPost.pro = projectName
    const { data } = await fetchLesson({ lessonId, dbId, projectId })
    const { title, body, authors,
      concept, summary, tags, categories, specialties, cover, file } = data
    this.showPost = {
      ...this.showPost,
      ...data,
      authors: authors.map(e => e.name).join('、'),
      domain: specialties.map(e => e.name).join('、'),
      title,
      body,
      concept,
      cover,
      file: !file.src ? null : file.src,
      tags: tags.length >= 1 ? tags.map(e => e.name) : categories.map(e => e.name)
    }
  },
  data() {
    return {
      showPost: {
        pro: ''
      }
    }
  },
}
</script>

<style lang="sass">
@import '@/assets/style.sass'
.tp
  width: 60%
  margin-left: 20%
  box-sizing: border-box
  margin-top: 3%
  +com
    min-height: 32vw
  +smallcom
    width: 80%
    margin-left: 10%
    min-height: 55vw

  +phone
    width: 95%
    margin-left: 2.5%
  .tpBlock
    width: 100%
    .tpTop
      width: 100%
      min-height: 17vw
      // +bb
      +flexrow
      +phone
        +flexcolumn
      //標題區
      .tpLeft
        width: 45%
        border-left: solid 1px #878787
        +phone
          width: 86%
          // +bb
        .tpTitle
          font-size: 1.8vw
          font-weight: 800
          color: #878787
          margin-left: 1vw
          +pad
            font-size: 2.5vw
          +phone
            font-size: 5vw
        .tpSubTitle
          font-size: 1vw
          margin-top: 1vw
          margin-left: 1vw
          color: #878787
          letter-spacing: 0.1vw
          +phone
            font-size: 4vw
            margin-top: 2vw
            line-height: 10vw


        .tpPro
          font-size: 1vw
          margin-top: 0.5vw
          margin-left: 1vw
          color: #878787
          letter-spacing: 0.1vw
          +phone
            font-size: 4vw
            margin-top: 2vw

      //封面照
      .tpPic
        // +bb
        border-color: #878787
        width: 50%
        margin-left: 5%
        +phone
          width: 100%
          height: 60vw
          margin-left: 0
          margin-top: 3vw
          max-width: none
          // border: 0
          background-size: 100% auto !important
          background-position: 0 0 !important
    //文字內容
    .toContent
      width: 100%
      // +bb
      border-bottom: solid 1px #878787
      // min-height: 1vw
      margin-top: 2vw
      padding: 0 0 1vw 0
      color: #878787 !important
      font-size: 1vw
      +phone
        padding: 0 0 3vw 0
        font-size: 4vw
        line-height: 10vw
      img
        width: 100%
        object-fit: cover
      table
        border-collapse: collapse
        width: 100% !important
        ul, ol
          list-style-position: inside
        td
          padding: 4px

    //TAG
    .TpTagBlock
      width: 100%
      +flexrow
      +phone
        margin-top: 3vw
      .TpTag
        color: #878787
        margin-top: 1vw
        margin-right: 0.5vw
</style>


// WEBPACK FOOTER //
// src/views/Teach/TeachPost.vue